import React from "react";
import { countObjectsWithValue } from "../../lib/countObjects";
import rootDir from "../..";
import { Link } from "react-router-dom";

interface Props {
    trackData: any;
    myRegion: string;
    searchRegion: string;
    displayPage: string;
}
interface Prop2 {
    displayPage: string;
    trackNo: any;
}

const TrackNumber = ({displayPage, trackNo}: Prop2) => {
    return (
        <div>{displayPage === "album" ? trackNo : <img src={rootDir+"img/verified.png"} alt="Listed" height={15}/>}</div>
    )
}

const TrackList = ({trackData, myRegion, searchRegion, displayPage }: Props) => {
    return (
        <table id="trackListTable" border={0}>
            <thead>
                {/* <tr><th colSpan={10}>Tracklist</th></tr> */}
                <tr>
                    <th>#</th>
                    {displayPage === "artist" ? null : <th>Artist</th>}
                    <th>Title</th>
                    {displayPage === "album" ? null : <th>Album</th>}
                    <th>Time</th>
                    <th>Genre</th>
                    <th>Arr</th>
                    <th>DLC</th>
                    <th>Region</th>
                    {/* <th>Note</th> */}
                </tr>
            </thead>
            <tbody>
                { trackData ? Object.keys(trackData).map((i, j) => (
                    <tr key={i} className={trackData[i].is_available ? "" : "delistedSong"}>
                        <td>{trackData[i].is_available ? <TrackNumber displayPage={displayPage} trackNo={i}/> : <div><img src={rootDir+"img/delisted.png"} height={20} alt="Delisted" title="Song is delisted."/></div> }</td>
                        {displayPage === "artist" ? null : <td>{trackData[i].inhouse_cover ? <span className="inhouseCover" title="Made Famous By">(MFB) </span> : null}<Link to={rootDir+'artist/'+trackData[i].artist_id}
                                >{trackData[i].artist}</Link></td>}
                        <td className={trackData[i].inhouse_cover ? 'inhouseCover' : 'songs'} title={ trackData[i].inhouse_cover ? 
                                    'This song is flagged as an inhouse cover, it is not the original recording' : 
                                    trackData[i].title}
                                ><Link to={rootDir+'song/'+trackData[i].song_id}
                            >{trackData[i].title} {trackData[i].has_lyrics ? <img src={rootDir+"img/lyrics.png"} alt="Has Lyrics" title="Has Lyrics" height={16}/> : null} {trackData[i].explicit ? <img src={rootDir+"img/explicit.png"} alt="Explicit Lyrics" title="Explicit Lyrics" height={16}/> : null} </Link></td>
                        {displayPage === "album" ? null : <td><Link to={rootDir+'album/'+trackData[i].album_id}
                            >{trackData[i].album_cover ? <img src={trackData[i].album_cover} height={15} alt="Album Cover"/> : null} {trackData[i].album_title}</Link></td>}
                        <td className="songlength">{trackData[i].time}</td>
                        <td className="genre">{ Object.keys(trackData[i].genre).map((k,l) => (<button title={trackData[i].genre[l]}>{trackData[i].genre[l]}</button>)) }</td>
                        <td className="arr-cell">{Object.keys(trackData[i].arrangements).map((k,l) => (<img src={rootDir+'img/arr/'+k+'.png'} alt={k} title={k} height={16} />))}</td>
                        <td className="dlc-cell">{ trackData[i].is_official_rs1 === true ? <img src={rootDir+'img/RS1.png'} alt='Official RS1 DLC' height={16} title='Official RS1 DLC' /> : null} {trackData[i].is_official_rs2014 === true ? <img src={rootDir+'img/RS2014.png'} alt='Official RS2014 DLC' height={16} title='Official RS2014 DLC' /> : null} {trackData[i].was_in_beta === true ? <img src={rootDir+'img/RS+.png'} alt='Was in RS+ Beta' height={16} title='Was in RS+ Beta' /> : null}</td>
                        <td className="region-cell">{trackData[i].region[myRegion] ? <img src={rootDir+'img/flag/'+myRegion+'.png'} alt={myRegion} height={16} title={"Available in "+myRegion}/> : null} {trackData[i].region[searchRegion] ? <img src={rootDir+'img/flag/'+searchRegion+'.png'} alt={searchRegion} height={16} title={"Available in "+searchRegion}/> : null} <span className="reg-y"><select className="reg-y"><option selected>Yes:&nbsp;{countObjectsWithValue(trackData[i].region, true)}</option>{Object.entries(trackData[i].region).map(([i,v],j) => (v === true ? <option>{i}</option> : null))}</select></span> <span className="reg-n">No:&nbsp;{countObjectsWithValue(trackData[i].region, false)}</span></td>
                    </tr>
                )) : null }
            </tbody>
        </table>
    )
}

export default TrackList